import { getBusinessObject } from 'bpmn-js/lib/util/ModelUtil'

import { createElement, createRaci, getRoles, getSistemivRaciExtension } from '../util'

import RoleProps from './RoleProperties'

import { without } from 'min-dash'

export default function RaciProps({ element, injector }) {
  const roles = getRoles(element) || []

  const bpmnFactory = injector.get('bpmnFactory'),
    commandStack = injector.get('commandStack')
  const items = roles.map((role, index) => {
    const id = element.id + '-role-' + index

    return {
      id,
      label: role?.role || 'Role',
      entries: RoleProps({
        idPrefix: id,
        element,
        role,
      }),
      autoFocusEntry: id + '-name',
      remove: removeFactory({ commandStack, element, role }),
    }
  })

  return {
    items,
    add: addFactory({ element, bpmnFactory, commandStack }),
  }
}

function removeFactory({ commandStack, element, role }) {
  return function (event) {
    event.stopPropagation()

    const sistemivRaciExtension = getSistemivRaciExtension(element)

    if (!sistemivRaciExtension) {
      return
    }

    const roles = without(sistemivRaciExtension.get('roles'), role)

    commandStack.execute('element.updateModdleProperties', {
      element,
      moddleElement: sistemivRaciExtension,
      properties: {
        roles: roles,
      },
    })
  }
}

function addFactory({ element, bpmnFactory, commandStack }) {
  return function (event) {
    event.stopPropagation()

    const commands = []

    const businessObject = getBusinessObject(element)

    let extensionElements = businessObject.get('extensionElements')

    if (!extensionElements) {
      extensionElements = createElement('bpmn:ExtensionElements', { values: [] }, businessObject, bpmnFactory)

      commands.push({
        cmd: 'element.updateModdleProperties',
        context: {
          element,
          moddleElement: businessObject,
          properties: { extensionElements },
        },
      })
    }

    let sistemivRaciExtension = getSistemivRaciExtension(element)

    if (!sistemivRaciExtension) {
      sistemivRaciExtension = createRaci(
        {
          roles: [],
        },
        extensionElements,
        bpmnFactory,
      )

      commands.push({
        cmd: 'element.updateModdleProperties',
        context: {
          element,
          moddleElement: extensionElements,
          properties: {
            values: [...extensionElements.get('values'), sistemivRaciExtension],
          },
        },
      })
    }

    const roles = getRoles(element) || []

    if (roles.length > 0) {
      const newRole = createElement(
        'sistemiv:Role',
        {
          role: '',
          stakeholder: '',
        },
        sistemivRaciExtension,
        bpmnFactory,
      )

      commands.push({
        cmd: 'element.updateModdleProperties',
        context: {
          element,
          moddleElement: sistemivRaciExtension,
          properties: {
            roles: [...sistemivRaciExtension.get('roles'), newRole],
          },
        },
      })
    } else if (roles.length === 0) {
      const aRole = createElement(
        'sistemiv:Role',
        {
          role: 'Accountable',
          stakeholder: '',
        },
        sistemivRaciExtension,
        bpmnFactory,
      )

      const rRole = createElement(
        'sistemiv:Role',
        {
          role: 'Responsible',
          stakeholder: '',
        },
        sistemivRaciExtension,
        bpmnFactory,
      )

      commands.push({
        cmd: 'element.updateModdleProperties',
        context: {
          element,
          moddleElement: sistemivRaciExtension,
          properties: {
            roles: [aRole, rRole],
          },
        },
      })
    }

    commandStack.execute('properties-panel.multi-command-executor', commands)
  }
}
